export const TRACKING_EVENTS = {
  SAVE: `Custom Property - save`,
  INSERT_EXAMPLE: `Custom Property - insert example`,
  CANCEL: `Custom Property - cancel`,

  CLICK_UPSELL: `Click Upsell`,
};
